"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M9.5 10a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M6 5.5A1.5 1.5 0 0 1 7.5 4h6a.5.5 0 0 1 .354.146l4 4A.5.5 0 0 1 18 8.5v1h.5A1.5 1.5 0 0 1 20 11v6.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 17.5v-7A1.5 1.5 0 0 1 5.5 9H6zM7.5 5a.5.5 0 0 0-.5.5v5A1.5 1.5 0 0 0 8.5 12h7a1.5 1.5 0 0 0 1.5-1.5V9h-2.5A1.5 1.5 0 0 1 13 7.5V5zm6.5.707V7.5a.5.5 0 0 0 .5.5h1.793zM17 18v-.5a1.5 1.5 0 0 0-1.5-1.5h-7A1.5 1.5 0 0 0 7 17.5v.5z"
  })]
}), 'PrinterFilled');
//# sourceMappingURL=index.js.map